import { lazy } from "react";
import { CiMonitor } from "react-icons/ci";
import { BankOutlined, DollarOutlined, DownloadOutlined } from "@ant-design/icons";
import Companies from "../pages/auth/Internal/Companies";
import CommingSoon from "../pages/other/coming_soon";
import Subscription from "../pages/auth/Internal/Subscriptions";

// Pages
const Dashboard = lazy(() => import("../pages/auth/Dashboard"));

export const MENU_LIST_INTERNAL = [
  {
    name: "Dashboard",
    code: "Dashboard",
    icon: <CiMonitor />,
    path: "/dashboard",
    element: <CommingSoon />,
  },
  {
    name: "Companies",
    code: "Companies",
    icon: <BankOutlined />,
    path: "/companies",
    element: <Companies />,
  },
  {
    name: "Subscription",
    code: "Subscription",
    icon: <DollarOutlined />,
    path: "/subscription",
    element: <Subscription />,
  },
];
